export default __webpack_public_path__ + "static/media/juresta-login-part-right.1408cb17.svg";